import React from 'react';
import {  FiMoreVertical, FiSearch, FiUserPlus } from 'react-icons/fi'
import { contacts } from '../../../../dummy/contacts';

const Contacts = () => {
    return (
      <React.Fragment>
        <div className="m-3 mx-4">
                <div className="flex items-center justify-between">
                  <div className="font-semibold">Contacts</div>
                  <div className="flex">
                    <FiUserPlus className="h-4 text-gray-500" />
                  </div>
                </div>
                <div className="search mt-3">
                  <div
                    className="bg-gray-200 dark:bg-[#111] flex items-center px-3 rounded-md"
                  >
                    <FiSearch className="stroke-gray-500" />
                    <input
                      placeholder="Search"
                      type="text"
                      className="w-full border-none bg-transparent p-3 outline-none"
                    />
                  </div>
                </div>
  
              {contacts.map((contact,i)=>(
                 <React.Fragment key={`contact-${i}`} >
                  <h4 className="text-blue-500 text-xl cursor-pointer my-1">{contact.group}</h4>
                  <ul className="grid">
                    {contact.list?.map((user,key)=>(
                        <li
                        key={`list-${key}`}
                        className="group flex items-center justify-between hover:bg-gray-200 p-1 rounded-md cursor-pointer"
                      >
                        <div className="font-medium text-gray-500">{user.name}</div>
                        <FiMoreVertical
                          className="h-4 text-gray-400 -hidden group-hover:flex"
                        /> 
                      </li>
                    ))}
                  </ul>
                </React.Fragment>
              ))}

        </div>
      </React.Fragment>
    )
  }

export default Contacts;

